"use client";

import { Building2, Map as MapIcon, Target } from "lucide-react";
import { NeighborhoodSelector } from "../steps/search/neighborhood-selector";
import { MarketLimitedComponent } from "./market-limited-component";

const NEIGHBORHOOD_HIGHLIGHTS = [
  {
    title: "Interactive Map",
    description:
      "Explore Denver neighborhoods with our interactive map interface",
    icon: MapIcon,
  },
  {
    title: "Market Insights",
    description: "View detailed stats and trends for each neighborhood",
    icon: Target,
  },
  {
    title: "Local Knowledge",
    description:
      "Get insider information about amenities, lifestyle, and community",
    icon: Building2,
  },
];

interface NeighborhoodSelectorSectionProps {
  informativeOnly?: boolean;
}

export function NeighborhoodSelectorSection({
  informativeOnly = false,
}: NeighborhoodSelectorSectionProps) {
  return (
    <MarketLimitedComponent
      title="Neighborhood Explorer Coming Soon"
      description="Our interactive neighborhood explorer is currently available in Denver, CO. Discover detailed insights about each neighborhood, from market trends to lifestyle characteristics."
      featureHighlights={NEIGHBORHOOD_HIGHLIGHTS}
    >
      <NeighborhoodSelector informativeOnly={informativeOnly} />
    </MarketLimitedComponent>
  );
}
